const GuidelineIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2007_2550)">
        <path
          d="M0.416672 4.1665V15.8332L10 19.5832M0.416672 4.1665L10 7.9165M0.416672 4.1665L5.20834 2.2915M10 19.5832L19.5833 15.8332V4.1665M10 19.5832V7.9165M19.5833 4.1665L10 0.416504L5.20834 2.2915M19.5833 4.1665L14.7917 6.0415M10 7.9165L14.7917 6.0415M14.7917 6.0415L5.20834 2.2915"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2007_2550">
          <rect width="20" height="20" fill="none" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GuidelineIcon
